import { DateRange } from "../components/assessments/MeasurementDashboard/components/DateRangeFilter";

/**
 * Filters an array of data points by the given DateRange.
 *
 * - If range.kind === 'count', returns the last N items (by array order, which
 *   is assumed to be chronological ascending).
 * - If range.kind === 'time' and start is null, returns all items ("All History").
 * - Otherwise filters items whose date falls within [start, end].
 */
export function filterByDateRange<T extends { date: string }>(
  data: T[],
  range: DateRange,
): T[] {
  if (range.kind === "count") {
    return data.slice(-range.lastN);
  }

  // kind === 'time'
  if (!range.start) return data;

  return data.filter((item) => {
    const itemDate = new Date(item.date);
    return itemDate >= range.start! && (!range.end || itemDate <= range.end);
  });
}
